import { Typography } from "@mui/material";
import { Box, color } from "@mui/system";
import hearth from "../../assets/ic_hearth.svg";
import { OximeterState } from "../../ProSimulator/OximeterSimulator";
import { colors } from "../../Style";
import { keyframes } from "@mui/system";
import { getHighestSeverityAlarm } from "../../ProSimulator/Alarm";
import { ALARM_CODE } from "../../ProSimulator/Alarm";
import { useState, useEffect } from "react";
import { blink } from "../../Style";
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import { Translate, translate } from "react-i18nify";
export const MiddleComponent = (props) => {
  let oximeter = props.pro?.oximeter;

  const [oximeterAlarm, setOximeterAlarm] = useState("");
  const [oximeterAlarmCritical, setOximeterAlarmCritical] = useState(false);
  const [noSignalColor, setNoSignalColor] = useState("white");
  const [pulseAlarm, setPulseAlarm] = useState(null);
  const [pulseColor, setPulseColor] = useState(colors().TEXT_COLOR);
  const [batteryFail, setBatteryFail] = useState(null);
  const getTextColorFromAlarm = (alarm) => {
    switch (alarm?.alarmCode) {
      case ALARM_CODE.HIGH_PULSE:
      case ALARM_CODE.LOW_PULSE:
        return colors().COLORS_ALARM_LOW;
      case ALARM_CODE.CRITICALLY_HIGH_PULSE:
      case ALARM_CODE.CRITICALLY_LOW_PULSE:
      case ALARM_CODE.OXIMETER_NOT_CONNECTED: 
        return colors().COLORS_ALARM_HIGH;
      case ALARM_CODE.OXIMETER_NO_SIGNAL:      
      case ALARM_CODE.OXIMETER_NO_SIGNAL_DELAY_0:
      case ALARM_CODE.OXIMETER_NO_SIGNAL_DELAY_1:
      case ALARM_CODE.OXIMETER_NO_SIGNAL_DELAY_5:
      case ALARM_CODE.OXIMETER_NO_SIGNAL_DELAY_15:
      case ALARM_CODE.OXIMETER_NO_SIGNAL_DELAY_30:
      case ALARM_CODE.OXIMETER_WEAK_SIGNAL:
        return colors().COLORS_ALARM_LOW      
      default:
        return colors().TEXT_COLOR;
    }
  };

  const getOximeterAlarmMessage = (alarm) => {
    switch (alarm.alarmCode) {
      case ALARM_CODE.OXIMETER_NOT_CONNECTED:
        return OximeterState.NOT_CONNECTED;
      case ALARM_CODE.OXIMETER_NO_SIGNAL:      
      case ALARM_CODE.OXIMETER_NO_SIGNAL_DELAY_0:
      case ALARM_CODE.OXIMETER_NO_SIGNAL_DELAY_1:
      case ALARM_CODE.OXIMETER_NO_SIGNAL_DELAY_5:
      case ALARM_CODE.OXIMETER_NO_SIGNAL_DELAY_15:
      case ALARM_CODE.OXIMETER_NO_SIGNAL_DELAY_30:
        return OximeterState.NO_SIGNAL;
      case ALARM_CODE.OXIMETER_WEAK_SIGNAL:
      case ALARM_CODE.OXIMETER_WEAK_SIGNAL_CRITICAL:
        return OximeterState.WEAK_SIGNAL
      default:
        return "";
    }
  }

  useEffect(() => {
    let pulseAlarm = getHighestSeverityAlarm(props.pro?.alarms, [
      ALARM_CODE.CRITICALLY_HIGH_PULSE,
      ALARM_CODE.HIGH_PULSE,
      ALARM_CODE.LOW_PULSE,
      ALARM_CODE.CRITICALLY_LOW_PULSE,
    ]);
    setPulseAlarm(pulseAlarm != 0 ? pulseAlarm : null)
    setPulseColor(getTextColorFromAlarm(pulseAlarm));

    let batteryFail = getHighestSeverityAlarm(props.pro?.alarms, [
      ALARM_CODE.BATTERY_FAIL
    ]);
    setBatteryFail(batteryFail);

    let oximeterAlarm = getHighestSeverityAlarm(props.pro?.alarms, [
      ALARM_CODE.OXIMETER_NOT_CONNECTED,
      ALARM_CODE.OXIMETER_NO_SIGNAL,
      ALARM_CODE.OXIMETER_NO_SIGNAL_DELAY_0,
      ALARM_CODE.OXIMETER_NO_SIGNAL_DELAY_1,
      ALARM_CODE.OXIMETER_NO_SIGNAL_DELAY_5,
      ALARM_CODE.OXIMETER_NO_SIGNAL_DELAY_15,
      ALARM_CODE.OXIMETER_NO_SIGNAL_DELAY_30,
      ALARM_CODE.OXIMETER_WEAK_SIGNAL,
      ALARM_CODE.OXIMETER_WEAK_SIGNAL_CRITICAL
    ]);
    if (oximeterAlarm != 0 && oximeterAlarm != undefined) {
      if(oximeterAlarm.alarmCode === ALARM_CODE.OXIMETER_NOT_CONNECTED  || oximeterAlarm.alarmCode === ALARM_CODE.OXIMETER_NO_SIGNAL || oximeterAlarm.alarmCode === ALARM_CODE.OXIMETER_WEAK_SIGNAL_CRITICAL){
        setOximeterAlarmCritical(true);
      }
      else
        setOximeterAlarmCritical(false);

      setOximeterAlarm({
        "message": getOximeterAlarmMessage(oximeterAlarm),
        "alarmCode": oximeterAlarm.alarmCode
      });
      return;
    }
    setOximeterAlarmCritical(false);
    setOximeterAlarm({"message":"", "alarmCode": 0 });
  }, [props.pro?.alarms]);

  const ErrorSection = () => {
    return(
      <Box
        sx={{
          mt: 1,
          width: "100%",
          height: props.isManual ? "10%" : "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="h7"
          sx={{
            color: pulseColor,
            fontWeight: "bold",
            color: pulseColor,
            animation: `${blink} 0.5s infinite`,
          }}
        >
          {translate(pulseAlarm?.name)}
        </Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ width: "100%", height: "100%" }}>

      <Box sx={{ width: "100%", height: "20%" }}>
        {//ALARM BOX----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
        }
        <Box
          sx={{
            width: "100%",
            height: "50%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              color: oximeterAlarmCritical ? colors().COLORS_ALARM_HIGH : getTextColorFromAlarm(oximeterAlarm),
              animation: oximeterAlarmCritical
                ? `${blink} 0.5s infinite`
                : null,
              fontWeight: "bold",
            }}
          >
            { translate(oximeterAlarm.message) == "" ? null : translate(oximeterAlarm.message)}
          </Typography>
        </Box>
        {props.pro?.formating?.isFormating ? (
          <Box
            sx={{

              width: "100%",
              height: "50%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{ fontWeight: "bold", color: colors().COLORS_ALARM_LOW }}
            >
              Formating...
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              visibility: batteryFail != null ? "visible" : "hidden",
              width: "100%",
              height: "50%",
              display: "flex",
              justifyContent: "center",
              animation: `${blink} 0.5s infinite`,
            }}
          >
            <Typography
              sx={{ fontWeight: "bold", color: colors().COLORS_ALARM_HIGH }}
            >
              {batteryFail?.name}
            </Typography>
          </Box>
        )}
      </Box>
      {
        !props.showVital ? 
          <>
            {/* <Box sx={{ height:"100%", mt:11.5 }} >
              <ErrorSection/>
            </Box> */}
          </>
        :
        <>
        <Box
          id="box0"
          sx={{
            width: "100%",
            height: "26%",
            position: "relative",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            id="box1"
            component="img"
            src={hearth}
            alt="Pulse"
            sx={{
              width: "100%",
              height: "100%",
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
            }}
          />
          <Typography
            variant="h5"
            sx={{
              color: pulseColor,
              fontWeight: "bold",
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
            }}
          >
            <Box
              id="box5"
              sx={{
                color: colors().COLORS_ALARM_LOW,
                display: "flex",
                flexDirection: "column",
                position: "absolute",
                top: "7px",
                right: "50px",
              }}
            >
              {oximeter?.state == OximeterState.WEAK_SIGNAL 
                ? <DoDisturbIcon

                  />
                : <></>
              }
            </Box>
            <Box
              sx={{
                fontWeight: "bold",
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
              }}
            >
              {oximeter?.state == OximeterState.SIGNAL_DATA || oximeter?.state == OximeterState.WEAK_SIGNAL
                ? oximeter?.pulse
                : "---"}
            </Box>
          </Typography>
        </Box>
        <ErrorSection/>
        </>
        }
      <Box
        id="box2"
        sx={{
          display: props.isManual ? "flex" : "none",
          alignItems: "end",
          height:props.isManual ? props.showVital ? "34%" : "70%" : "70%",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            alignSelf: "end",
            color: pulseColor,
            fontWeight: "bold",
            maxLines: 1,
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            color: colors().COLORS_ALARM_LOW,
          }}
        >
          <Translate value="NoPatientAlarms" />
        </Typography>
      </Box>
      
    </Box>
  );
};
